// src/components/quiz/NewQuizDialog.jsx
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stepper,
    Step,
    StepLabel,
    Box,
    ToggleButtonGroup,
    ToggleButton,
    Typography,
    Checkbox,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import DeleteIcon from '@mui/icons-material/Delete';
import QuizForm from './QuizForm';

const NewQuizDialog = ({ open, onClose, onSuccess, user }) => {
    const [activeStep, setActiveStep] = useState(0);
    const [isEntireGame, setIsEntireGame] = useState(false);
    const [groups, setGroups] = useState([]);
    const [games, setGames] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        xp: 100,
        coin: 0,
        isLimitedTime: false,
        startDate: '',
        endDate: '',
        entireGame: false,
        groupIds: [],
        questions: [],
        gameIds: [],
        groupIds: [],
        maxAttempts: 1,
        secondsPerQuestion: 30,
    });

    const steps = ['Informações', 'Destino', 'Perguntas', 'Revisão'];

    useEffect(() => {
        if (open) {
            RequestService.getGroups(user.company.id)
                .then(setGroups)
                .catch(() => {});
        }
    }, [open]);

    const handleAddQuestion = () => {
        setFormData((prev) => ({
            ...prev,
            questions: [
                ...prev.questions,
                { title: '', position: prev.questions.length, options: [] },
            ],
        }));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const gamesData = await RequestService.getGames(
                    user.company.id
                );
                const groupsData = await RequestService.getGroups(
                    user.company.id
                );

                setGames(Array.isArray(gamesData) ? gamesData : []);
                setGroups(Array.isArray(groupsData) ? groupsData : []);
            } catch (err) {
                console.error('Erro ao carregar jogos/grupos');
            }
        };

        if (open) {
            fetchData();
        }
    }, [user.company.id, open]);

    const handleAddOption = (qIndex) => {
        const updated = [...formData.questions];
        updated[qIndex].options.push({ text: '', correct: false });
        setFormData({ ...formData, questions: updated });
    };

    const handleSubmit = async () => {
        const payload = {
            ...formData,
            companyId: user.company.id,
            startDate: formData.isLimitedTime ? formData.startDate : null,
            endDate: formData.isLimitedTime ? formData.endDate : null,
        };

        try {
            await RequestService.createQuiz(payload);
            onSuccess('Quiz criado com sucesso!');
            onClose();
        } catch {
            alert('Erro ao criar quiz.');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Novo Quiz</DialogTitle>
            <DialogContent>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{ mb: 2 }}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <QuizForm
                    formData={formData}
                    setFormData={setFormData}
                    user={user}
                    activeStep={activeStep}
                    games={games}
                    groups={groups}
                />
            </DialogContent>
            <DialogActions>
                {activeStep > 0 && (
                    <Button onClick={() => setActiveStep((s) => s - 1)}>
                        Voltar
                    </Button>
                )}
                {activeStep < steps.length - 1 ? (
                    <Button onClick={() => setActiveStep((s) => s + 1)}>
                        Próximo
                    </Button>
                ) : (
                    <Button variant="contained" onClick={handleSubmit}>
                        Criar Quiz
                    </Button>
                )}
                <Button onClick={onClose}>Cancelar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewQuizDialog;
